import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalizationModule } from '@kaltura-ng/mc-shared';
import { AreaBlockerModule, PopupWidgetModule } from '@kaltura-ng/kaltura-ui';

import { QRCodeModule } from 'angularx-qrcode';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PreviewEmbedDetailsComponent } from './preview-embed.component';
import { PreviewEmbedComponent } from './preview-and-embed.component';

@NgModule({
  imports: [
    CommonModule,
    PopupWidgetModule,
    AreaBlockerModule,
    FormsModule,
    ReactiveFormsModule,
    LocalizationModule,
    ButtonModule,
    DropdownModule,
    InputTextareaModule,
    InputSwitchModule,
    RadioButtonModule,
    QRCodeModule,
  ],
  declarations: [PreviewEmbedComponent, PreviewEmbedDetailsComponent],
  providers: [],
  exports: [PreviewEmbedComponent],
})
export class PreviewAndEmbedModule {}
